var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadCerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 36.669,
    height: 26.306,
    viewBox: "0 0 36.669 26.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload-cer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30351",
    "data-name": "Rectangle 30351",
    width: 36.669,
    height: 26.306,
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_880",
    "data-name": "Mask Group 880",
    clipPath: "url(#upload-cer)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_18_",
    "data-name": "svgexport-7 (18)",
    transform: "translate(3.268 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86090",
    "data-name": "Group 86090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86089",
    "data-name": "Group 86089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86088",
    "data-name": "Group 86088"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3263",
    "data-name": "Ellipse 3263",
    cx: 2.064,
    cy: 2.064,
    rx: 2.064,
    ry: 2.064,
    transform: "translate(9.26 6.565)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48024",
    "data-name": "Path 48024",
    d: "M28.266,20.364a6.356,6.356,0,0,0-3.555-1.691V8.18a4.127,4.127,0,0,0-1.175-2.867,4.006,4.006,0,0,0-2.867-1.175H4.042A4.127,4.127,0,0,0,1.175,5.313,4.006,4.006,0,0,0,0,8.18V25.295a4.127,4.127,0,0,0,1.175,2.867,4.006,4.006,0,0,0,2.867,1.175H20.125a6.065,6.065,0,0,0,8.142-8.973ZM1.519,8.18a2.4,2.4,0,0,1,.745-1.749,2.515,2.515,0,0,1,1.777-.745H20.669a2.545,2.545,0,0,1,2.523,2.523v8.944L18.949,12.91a.77.77,0,0,0-1.089,0l-6.393,6.422L7.138,14.974a.77.77,0,0,0-1.089,0l-4.53,4.587ZM4.013,27.875v-.057a2.515,2.515,0,0,1-1.777-.745,2.616,2.616,0,0,1-.717-1.777V21.74l5.074-5.1,4.329,4.329a.8.8,0,0,0,1.089,0L18.4,14.544l4.185,4.214-.258.086a2.663,2.663,0,0,0-.373.115c-.115.029-.229.086-.344.115a.858.858,0,0,0-.229.115,2.664,2.664,0,0,0-.287.143l-.43.258c-.086.057-.143.086-.229.143-.057.029-.086.057-.143.086a3.459,3.459,0,0,0-.688.6,6.065,6.065,0,0,0-1.777,4.3,6.3,6.3,0,0,0,.143,1.261c.029.115.057.2.086.315.086.287.172.573.287.86v.029a5.259,5.259,0,0,0,.373.688Zm23.135,0a4.535,4.535,0,0,1-6.336.057c-.115-.115-.229-.258-.344-.373-.086-.086-.172-.2-.258-.287a2.722,2.722,0,0,1-.287-.487c-.057-.115-.115-.2-.172-.315a2.421,2.421,0,0,1-.143-.487c-.029-.115-.086-.258-.115-.373a4.745,4.745,0,0,1-.086-.917,4.6,4.6,0,0,1,1.319-3.211,4.432,4.432,0,0,1,3.211-1.319,4.6,4.6,0,0,1,3.211,1.319,4.481,4.481,0,0,1,1.319,3.211A4.585,4.585,0,0,1,27.148,27.875Z",
    transform: "translate(0 -4.138)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48025",
    "data-name": "Path 48025",
    d: "M54.565,45.816a1,1,0,0,0-.258-.172.837.837,0,0,0-.258-.057h-.057a.837.837,0,0,0-.258.057.677.677,0,0,0-.258.172L51.7,47.593a.77.77,0,0,0,1.089,1.089l.459-.459v3.153a.774.774,0,1,0,1.548,0V48.224l.459.459a.77.77,0,1,0,1.089-1.089Z",
    transform: "translate(-30.082 -28.357)",
    fill: "#7e59d1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCerIcon);
export default __webpack_public_path__ + "static/media/upload-cer-icon.a07b8c455f4e42e79c8b912970481466.svg";
export { ForwardRef as ReactComponent };